var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count === 50)?_c('span',{staticClass:"events-info float-right"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"fa fa-warning",attrs:{"title":_vm.n__(
      'Limited to showing %d event at most',
      'Limited to showing %d events at most',
      50
    ),"aria-hidden":"true","data-placement":"top"}}),_vm._v("\n  "+_vm._s(_vm.n__('Showing %d event', 'Showing %d events', 50))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }